<template>
  <div id="app">
    <div v-show="$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">{{$store.state.DLINE_ENVIRONMENT}}</div>
    <keep-alive :include="['GoodsList']">
        <!-- 需要缓存的视图组件 -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
      <!-- 不需要缓存的视图组件 -->
     <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      unionid:''
    };
  },
  watch: {
    '$route': {
      handler(to, from){
        if(this.$store.state.browser.ios && this.$store.state.browser.giantapp){
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; //改为manual之后，就不会记录滚动位置
          }
        }
      },
      immediate: true,//首次进入页面即执行
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  mounted(){
  },
  methods: {
    
  }

}
</script>

<style scoped lang="less">
.nothing_load .material-icons.big {
  transform-origin: 50% 100%;
  animation: nothing_load_ani 5s infinite;
}

@keyframes nothing_load_ani {
  0% {
    transform: translate(-10px) rotate(0deg);
  }
  5% {
    transform: translate(-5px) rotate(-10deg);
  }
  20% {
    transform: translate(10px) rotate(3deg);
  }
  50% {
    transform: translate(5px);
  }
  70% {
    transform: translate(10px);
  }
  100% {
    transform: translate(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue